import React, { useEffect, useRef, useState } from "react";
import "./Nudges.css";
import { useLocation, useParams } from "react-router-dom";
import * as FeatherIcon from 'react-feather';
import { useConfig } from "../../../../context/AppConfigContext";
import { getUserStatsObject, recordActivity, getUrlDetailsObj, getTabType } from "../../../../services/commonService";
import { useDispatch, useSelector } from "react-redux";
import { fetchAccBuNudgeRequest } from "../../../../store/features/actions/accountBuNudgesActions";
import NudgesSkeleton from "../../skeletons/nudgesSkeleton/nudgesSkeleton";
import NudgesWithPromptTiles from "./NudgesWithPromptTiles";
import NudgesWithPromptTilesV2Filters from "./NudgesWithPromptTilesV2Filters";
import NudgesWithPromptTilesV2 from "./NudgesWithPromptTilesV2";

export default function NudgesWithPrompts({active_tab_key,isBU}) {
  const dispatch = useDispatch();
  const {appConfig} = useConfig();

  const { account_info} = useSelector(state=>state?.accountsReducer)
  const [business_units, setBusinessUnits] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [activeUnit, setActiveUnit] = useState('All Business Segments');
  const [activeUnitNudges, setActiveUnitNudges] = useState([]);
  const { accountId, accountName, clientName } = useParams();
  const tabContainerRef = useRef(null); // Reference for tab container
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const [showArrows, setShowArrows] = useState(false); // New state to control arrow visibility

  const [activeAccordion, setActiveAccordion] = useState(0);  // Track accordion state (open/closed)
  const [selectedItems, setSelectedItems] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [copied, setCopied] = useState(false);

  var pageParsedData = getUrlDetailsObj(useLocation, useParams);
  pageParsedData.query_params = {}
  pageParsedData.query_params.tab = 'nudges_and_events';
  var tab_name = getTabType('nudges_and_events') || "";

  useEffect(() => {
    if(active_tab_key === 'nudges'){
      updateScrollButtons()
    }
}, [active_tab_key]);

  const updateBusinessUnits = () => {
    const business_units = account_info?.business_units || [];
    setBusinessUnits(business_units)
    const bu_tabs = business_units.map((unit) => unit.name);
    bu_tabs.unshift("All Business Segments")
    setTabs(bu_tabs)
    // setActiveUnit(bu_tabs[0]);
  }

  useEffect(() => {
    updateBusinessUnits();
  }, [account_info, accountId, accountName, clientName]);

  const {acc_bu_nudges,acc_bu_version,acc_bu_nudges_loading,acc_bu_nudges_error} = useSelector(state=>state?.accBuNudgeReducer)


  useEffect(() => {
    const nudges_types_key_val = appConfig?.nudges_types_key_val || [];
    const sortOrder = nudges_types_key_val.map(item => Object.keys(item)[0]);

    acc_bu_nudges.sort((a, b) => {
        return sortOrder.indexOf(a._id) - sortOrder.indexOf(b._id);
    });
    setActiveUnitNudges(acc_bu_nudges);
  }, [accountName,acc_bu_nudges_loading])

  
  useEffect(() => {
    if (activeUnit && active_tab_key !="business") {
      let userStat = getUserStatsObject(
        tab_name+" - "+activeUnit,
        "bu_change",
        "Page Source: " + accountName,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
      let active_bu = (activeUnit == "All Business Segments") ? 'all' : activeUnit
      dispatch(
        fetchAccBuNudgeRequest({accountName, clientName, bu_unit:active_bu})
      );
    }
  }, [activeUnit,accountName,clientName, appConfig?.nudges_types_key_val]);

  const updateScrollButtons = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      const canScrollLeftValue = tabContainer.scrollLeft > 0;
      const canScrollRightValue = tabContainer.scrollLeft + tabContainer.clientWidth < tabContainer.scrollWidth;

      setCanScrollLeft(canScrollLeftValue);
      setCanScrollRight(canScrollRightValue);

      // Show arrows only if the content is scrollable
      setShowArrows(tabContainer.scrollWidth > tabContainer.clientWidth);
    }
  };

  const scrollLeft = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: -200, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    const tabContainer = tabContainerRef.current;
    if (tabContainer) {
      tabContainer.scrollBy({ left: 200, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    updateScrollButtons(); // Initially check if scrolling is needed
    const tabContainer = tabContainerRef.current;
    
    if (tabContainer) {
      tabContainer.addEventListener('scroll', updateScrollButtons);
      window.addEventListener('resize', updateScrollButtons); // Recheck on window resize
    }

    return () => {
      if (tabContainer) {
        tabContainer.removeEventListener('scroll', updateScrollButtons);
      }
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [tabs]);

  useEffect(() => {
    setActiveAccordion('0'); // Set first accordion to open
    setSelectedItems([]); // Set selected items to null
  }, [activeUnit]);

  // console.log("nudges_wrapper",acc_bu_nudges_loading,activeUnitNudges)

  if (acc_bu_nudges_loading) {
    return (
      <div className="nudges_wrapper">
        <div className="nudges_accordian_block pb-4">
          <div className="container-fluid custom_card_block mt-4">
            <div className="promter_head_copy">
              <div className="promter_head_subblock">
                <div className="promters_head">
                  Nudges
                  <p className="top_para_promters">
                    Stay ahead in {account_info?.display_name} with targeted
                    nudges offering actionable insights on product launches,
                    market shifts, and competitive opportunities.
                  </p>
                </div>
              </div>
            </div>
            <div className="business_seg_tabs">
              <div className="navbar navbar-expand-lg container-fluid custom_subnavbar">
                {showArrows && (
                  <>
                    <button
                      className="scroll-btn left-arrow"
                      onClick={scrollLeft}
                      disabled={!canScrollLeft}
                    >
                      <FeatherIcon.ArrowLeftCircle className="icons_table mr-1" />
                    </button>
                  </>
                )}
                {showArrows && ( // Conditionally render arrows based on `showArrows` state
                  <>
                    <button
                      className="scroll-btn right-arrow"
                      onClick={scrollRight}
                      disabled={!canScrollRight}
                    >
                      <FeatherIcon.ArrowRightCircle className="icons_table mr-1" />
                    </button>
                  </>
                )}
              </div>
            </div>
            <div
            style={{display:'flex',justifyContent:"center",alignItems:'center'}}
            ><NudgesSkeleton /></div>
            
          </div>
        </div>
      </div>
    );
  }

  if (!acc_bu_nudges_loading && !activeUnitNudges?.length > 0 && isBU) {
    return (
      <div className="nudges_wrapper">
        <div className="nudges_accordian_block pb-4">
          <div className="container-fluid custom_card_block mt-4">
            <div className="promter_head_copy">
              <div className="promter_head_subblock">
                <div className="promters_head">
                  <h5 style={{fontWeight:"600"}}>Nudges</h5>
                  
                  <p>
                  Still searching for Nudges, please check back again in a few hours
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!acc_bu_nudges_loading && !activeUnitNudges?.length>0) {
    return null
  }

  // ++++++++++++++++++++
  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev);
  };

  const handleCopyToClipboard = () => {
    let textToCopy = "";
    if(clientName == "DELL OEM INDIA"){
      textToCopy = selectedItems
      .map((id) => {
        const nudge = activeUnitNudges.find((nudge) =>
          nudge.data[0].nudges.nudges.some((dataItem) => dataItem.id === id)
        );

        let userStat = getUserStatsObject(
          tab_name,
          "nudge_copy",
          "Page Source: " + accountName,
          window.location.href,
          accountId
        );
        userStat.url_details = pageParsedData;
        recordActivity(userStat);

        const dataItem = nudge?.data?.[0].nudges?.nudges?.find(
          (dataItem) => dataItem.id === id
        );

        return dataItem
          ? (dataItem?.event ? dataItem.event + "\n" : "") +
              dataItem?.potential_impact
          : "";
      })
      .join("\n\n");

    }else{
      textToCopy = selectedItems.map(id => {
        const nudge = activeUnitNudges.find(n =>
          n.nudges.some(dataItem => dataItem?.opportunity_id === id)
        );
        // trackUserActivity(tabName, "copy");

        const dataItem = nudge?.nudges?.find(
          item => item.opportunity_id === id
        );

        return dataItem
          ? `${dataItem?.nudge?.event ? dataItem?.nudge.event + "\n" : ""}${dataItem?.nudge?.potential_impact}`
          : "";
      }).join("\n\n");
    }


    navigator.clipboard.writeText(textToCopy).then(() => setCopied(true));
    setTimeout(() => setCopied(false), 2000);
  };

  // ++++++++++++++++++++

  return (
    <div className="nudges_wrapper">
      <div className="nudges_accordian_block pb-4">
        <div className="container-fluid custom_card_block mt-4">
          <div
            className="promter_head_copy"
            style={{ display: "flex", flexWrap: "wrap" }}
          >
            {/* Left Block */}
            <div
              className="promter_head_subblock col-md-9"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
                borderBottom: "0px",
              }}
            >
              <div className="promters_head" style={{
                // paddingLeft: '23px',
                fontWeight: 600,
                fontSize: '18px'
              }}>
                Nudges
                <p className="top_para_promters" style={{
                  fontSize: '14px',
                  fontStyle: 'italic',
                  color: '#64748B',
                  fontWeight: 400,
                  marginTop: '5px'
                }}>
                  Stay ahead in {account_info?.display_name} with targeted
                  nudges offering actionable insights on product launches,
                  market shifts, and competitive opportunities.
                </p>
              </div>
            </div>

            {/* Right Block */}
            <div
              className="col-md-3 mt-1"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                flexDirection: "row",
                gap: "10px",
              }}
            >

              <div className="copy_btn_block" style={{display:"flex",justifyContent:"flex-end" , alignItems:"center"}}>
              <div
                    className={`copy-message ${
                      copied ? "copy-fade-in" : "copy-fade-out"
                    }`}
                  >
                    Copied !
                </div>
                <button
                  disabled={selectedItems.length === 0}
                  className="copy_btn"
                  onClick={handleCopyToClipboard}
                  style={{
                    textDecoration: "none",
                    color: "#fff",
                    padding: "7px 10px",
                    borderRadius: "20px",
                    fontSize: "12px",
                    // marginTop: "15px",
                    // marginRight: "15px",
                    minWidth: "125px",
                    backgroundColor:
                      selectedItems.length === 0 ? "#b9bcbd" : "#164E63",
                    border:
                      selectedItems.length === 0 ? "none" : "1px solid #ccc",
                  }}
                >
                  <img src="/img/icons/copy.png" alt="logo" width="20" /> Copy{" "}
                  <span>{selectedItems.length}</span>
                </button>
               
              </div>
            </div>
          </div>

          {acc_bu_version == 1 && (
            <div className="business_seg_tabs">
              <div className="navbar navbar-expand-lg container-fluid custom_subnavbar">
                {showArrows && (
                  <>
                    <button
                      className="scroll-btn left-arrow"
                      onClick={scrollLeft}
                      disabled={!canScrollLeft}
                    >
                      <FeatherIcon.ArrowLeftCircle className="icons_table mr-1" />
                    </button>
                  </>
                )}
               {!isBU && <ul className="nav nav-tabs custom_nav_tab" ref={tabContainerRef}>
                {tabs.map((tab, index) => (
                  <li className="nav-item" key={`nudge_seg_unit_${tab}`}>
                    <a
                      className={`nav-link ${activeUnit === tab ? "active" : ""} ${index === 0 ? 'px-4' : '' }`}
                      onClick={() => setActiveUnit(tab)}
                    >
                      {tab}
                    </a>
                  </li>
                ))}
              </ul>}

                {/* <div className="filter_subblock mr-2">
                <div className="custom_block_toggle">
                  <Dropdown show={showDropdown} onToggle={toggleDropdown}>
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                    {activeUnit || 'Segment Filter by None'}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    <Dropdown.Item key='all' onClick={() => setActiveUnit('')} >
                        Segment Filter by None
                      </Dropdown.Item>
                      {tabs.map((tab, index) => (
                        <Dropdown.Item key={index} onClick={() => setActiveUnit(tab)} >
                        {tab}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div> */}

                {showArrows && ( // Conditionally render arrows based on `showArrows` state
                  <>
                    <button
                      className="scroll-btn right-arrow"
                      onClick={scrollRight}
                      disabled={!canScrollRight}
                    >
                      <FeatherIcon.ArrowRightCircle className="icons_table mr-1" />
                    </button>
                  </>
                )}
              </div>
            </div>
          )}

          <div className="nudges_custom_wrapper">
            <div className="custom_card_block_nud">
              {/* <h5 className="nudge_top_heading">Nudges</h5> */}
              <div className="nudges_custom_block">
              <div className="nudges_custom_accordian">
                    {activeUnit &&
                      (acc_bu_version == 1? (
                        <NudgesWithPromptTiles
                          activeUnitNudges={activeUnitNudges}
                          selectedItems={selectedItems}
                          setSelectedItems={setSelectedItems}
                          activeUnit={activeUnit}
                          activeAccordion={activeAccordion}
                          setActiveAccordion={setActiveAccordion}
                        />
                      )
                      //  : isBU ? (
                      //   <NudgesWithPromptTilesV2
                      //     activeUnitNudges={activeUnitNudges}
                      //     selectedItems={selectedItems}
                      //     setSelectedItems={setSelectedItems}
                      //     activeUnit={activeUnit}
                      //     activeAccordion={activeAccordion}
                      //     setActiveAccordion={setActiveAccordion}
                      //   />
                      // ) 
                      : (
                        <NudgesWithPromptTilesV2Filters
                          activeUnitNudges={activeUnitNudges}
                          selectedItems={selectedItems}
                          setSelectedItems={setSelectedItems}
                          activeUnit={activeUnit}
                          activeAccordion={activeAccordion}
                          setActiveAccordion={setActiveAccordion}
                          tabs={tabs}
                          setActiveUnit={setActiveUnit}
                        />
                      ))
                      }
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
